import React, { useState, useEffect } from 'react';
import { compactTableInputStyle, labelStyle } from '../CampaignBriefStyles';
import UsersCompactTable from '../../../generic/UsersCompactTable/UsersCompactTableNew';
import { InternalUsersLookup } from '../CampaignBriefLookupService';
import UserCompactTableColumnDefinitions from '../ColumnDefinitions/UserCompactTableColumnDefinitions';

const CampaignPlanner = ({ campaign, onChange, readOnly }) => {
    const [plannerName, setPlannerName] = useState('');
    
    useEffect(() => {
        setPlannerName(campaign?.plannerName ?? '');
        
    }, [campaign]);
    
    const onInputChange = (event) => {
        setPlannerName(event.target.value);
    };

    const handleDropdownClick = (searchResult) => {
        setPlannerName(searchResult.name);
        onChange(searchResult.name, searchResult.id);
    };
    

    return (
        <div style={{ width: 280 }}>
            <label style={labelStyle}>{window.translate('Planner')}</label>
            <UsersCompactTable
                id='campaign-planner'
                inputStyle={compactTableInputStyle}
                value={plannerName}
                onChange={onInputChange}
                minSearchLength={0}
                searchFunction={(searchTerm, params) => InternalUsersLookup(searchTerm, params)}
                tableColumnDefinitions={UserCompactTableColumnDefinitions}
                onDropdownClick={handleDropdownClick}
                disabled={readOnly}
                searchFilter={[]}
                errorName='Planner'
            />
        </div>
    );
};

export default CampaignPlanner;
